import { render } from "./ComAdd.vue?vue&type=template&id=6da5d733&scoped=true"
import script from "./ComAdd.vue?vue&type=script&lang=js"
export * from "./ComAdd.vue?vue&type=script&lang=js"

import "./ComAdd.vue?vue&type=style&index=0&id=6da5d733&lang=less&scoped=true"

import exportComponent from "E:\\wwwroot\\abz-shuzi\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6da5d733"]])

export default __exports__